<ng-container *ngFor="let option of options; trackBy: trackOption">
  <ng-container [ngSwitch]="option.type">

    <!-- Grouped Options -->
    <mat-expansion-panel *ngSwitchCase="'group'">
      <mat-expansion-panel-header (opened)="onGroupOpened(option.field)" [class]="'panel-header-'+(option.label?.split(' ').join('') || '')">
        <mat-panel-title *ngIf="option.showLabel">{{ option.label }}</mat-panel-title>
      </mat-expansion-panel-header>
      <menu-options-component
        [options]="option.options"
        [value]="option.field ? value[option.field] : value"
        (valueChange)="handleGroupChange($event, option.field)"
        name="{{option.field}}">
      </menu-options-component>
    </mat-expansion-panel>

<mat-expansion-panel *ngSwitchCase="'group-mode-checkbox'" [(expanded)]="panelOpenState">

  <mat-expansion-panel-header
    (opened)="onGroupOpened(option.field)"
    [class]="'panel-header-'+(option.label?.split(' ').join('') || '')">

    <mat-panel-title *ngIf="option.showLabel">
      {{ option.label }}
    </mat-panel-title>

  </mat-expansion-panel-header>

<div class="mode-section">
  <mat-radio-group
    class="mode-radio-group"
    [ngModel]="value[getBooleanOption(option.options).field]"
    (ngModelChange)="
      value[getBooleanOption(option.options).field] = $event;
      onValueChange(getBooleanOption(option.options).field)
    ">

    <mat-radio-button
      class="mode-radio"
      [value]="false"
      (click)="$event.stopPropagation()">
      Relaxed
    </mat-radio-button>

    <mat-radio-button
      class="mode-radio"
      [value]="true"
      (click)="$event.stopPropagation()">
      Strict
    </mat-radio-button>

  </mat-radio-group>
</div>

  <div class="checkbox-section">
    <mat-checkbox
      class="checkbox-item"
      *ngFor="let val of getMultiCheckboxOption(option.options).values"
      [(ngModel)]="value[getMultiCheckboxOption(option.options).field][val]"
      (change)="onValueChange(getMultiCheckboxOption(option.options).field)"
      (click)="$event.stopPropagation()">

      {{ val }}

    </mat-checkbox>
  </div>

</mat-expansion-panel>


    <!-- Multi Checkbox -->
    <div *ngSwitchCase="'multi-checkbox'" class="option-group id-menu-seperator">
      <div *ngIf="option.showLabel" style="padding: 3px">{{option.label}}</div>
      <div *ngFor="let val of option.values" style="padding-left: 10px">
        <mat-checkbox
          [(ngModel)]="value[option.field][val]"
          (click)="$event.stopPropagation();"
          (change)="onValueChange(option.field)"
          name="{{option.field}}_{{val}}"
          [id]="'multi-checkbox-'+val">
          {{ val }}
        </mat-checkbox>
      </div>
    </div>

    <!-- Single Radio -->
    <div *ngSwitchCase="'single-radio'" class="option-group id-menu-seperator">
      <div *ngIf="option.showLabel" style="padding: 3px">{{option.label}}</div>
      <mat-radio-group [(ngModel)]="value[option.field]" (change)="onValueChange(option.field)" name="{{option.field}}">
        <div *ngFor="let val of option.values">
          <mat-radio-button
            style="padding-left: 10px; padding-right: 10px"
            [value]="val"
            (click)="$event.stopPropagation();"
            [id]="'single-radio-'+option.field+'-'+val">
            {{ val }}
          </mat-radio-button>
        </div>
      </mat-radio-group>
    </div>

    <!-- Boolean Checkbox -->
    <mat-checkbox
      class="id-control-item"
      *ngSwitchCase="'boolean'"
      [(ngModel)]="value[option.field]"
      (click)="$event.stopPropagation();"
      (change)="onValueChange(option.field)"
      name="{{option.field}}"
      [id]="'bool-checkbox-'+option.label?.split(' ').join('')">
      {{ option.showLabel ? option.label : '' }}
    </mat-checkbox>

    <!-- Text Input -->
    <mat-form-field *ngSwitchCase="'text'" appearance="fill" class="id-control-item" (click)="$event.stopPropagation()">
      <mat-label *ngIf="option.showLabel">{{ option.label }}</mat-label>
      <input
        matInput
        [value]="option.defaultValue"
        [(ngModel)]="value[option.field]"
        [placeholder]="option.placeholder"
        [id]="'input-'+option.label?.split(' ').join('')"
        type="text"
        (ngModelChange)="onValueChange(option.field)"
        name="{{option.field}}">
    </mat-form-field>

    <!-- Number Input -->
    <mat-form-field *ngSwitchCase="'number'" appearance="fill" class="id-control-item" [id]="'input-'+option.field" (click)="$event.stopPropagation()">
      <mat-label *ngIf="option.showLabel">{{ option.label }}</mat-label>
      <input
        matInput
        [value]="option.defaultValue"
        [(ngModel)]="value[option.field]"
        [placeholder]="option.placeholder"
        type="number"
        (ngModelChange)="onValueChange(option.field)"
        name="{{option.field}}">
    </mat-form-field>

  </ng-container>
</ng-container>

<!-- Display form values for debugging -->
<!--<pre>{{ value | json }}</pre>-->
